import { useEffect, useMemo, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../_redux/user-actions/UserActionsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { usePersonnelUsersUIContext } from "../personnel-users/PersonnelUsersUIContext";
import { useTeacherUsersUIContext } from "../teacher-users/TeacherUsersUIContext";
import { useStudentUsersUIContext } from "../student-users/StudentUsersUIContext";
import { useParentUsersUIContext } from "../parent-users/ParentUsersUIContext";
import { IPListEditForm } from "./IPListEditForm";

export function IPListEdit({
  ids,
  showIPListEdit,
  closeIPListEdit
}) {
  // IP List UI Context
  const personnelUsersUIContext = usePersonnelUsersUIContext();
  const teacherUsersUIContext = useTeacherUsersUIContext();
  const studentUsersUIContext = useStudentUsersUIContext();
  const parentUsersUIContext = useParentUsersUIContext();
  const IPListUIContext = personnelUsersUIContext || teacherUsersUIContext || studentUsersUIContext || parentUsersUIContext;

  const IPListUIProps = useMemo(() => {
    return {
      setIds: IPListUIContext.setIds,
      queryParams: IPListUIContext.queryParams
    };
  }, [IPListUIContext]);

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, IPList } = useSelector(
    (state) => ({
      actionsLoading: state.userActions.actionsLoading,
      isSuccess: state.userActions.isSuccess,
      type: state.userActions.type,
      IPList: state.userActions.IPList
    }),
    shallowEqual
  );
    
  useEffect(() => {
    if (ids && ids.length === 1) dispatch(actions.getIPList(ids));
    return () => dispatch(actions.cleanIPList());
  }, [ids, dispatch]);

  useEffect(() => {
    let _title = "IP Listesi Düzenle";
    setTitle(_title);
  }, [ids]);

  /** Belli Bir Kullanıcı Listesinin Sisteme Giriş Yapabileceği IP Listesini Kaydeder */
  const saveIPList = (values) => {
    dispatch(actions.saveIPList(ids, values.IPList)).then((result) => onResult(result));
  };
    
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        closeIPListEdit();
        IPListUIProps.setIds([]);
        dispatch(actions.cleanUserActionsState());
        if (personnelUsersUIContext) dispatch(actions.getPersonnelUsers(IPListUIProps.queryParams));
        else if (teacherUsersUIContext) dispatch(actions.getTeacherUsers(IPListUIProps.queryParams));
        else if (studentUsersUIContext) dispatch(actions.getStudentUsers(IPListUIProps.queryParams));
        else if (parentUsersUIContext) dispatch(actions.getParentUsers(IPListUIProps.queryParams));
      }, 2500);
    }
  };

  const btnRef = useRef();
  const saveIPListClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Modal
      show={showIPListEdit}
      onHide={closeIPListEdit}
      aria-labelledby="IP-list-title"
    >
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="IP-list-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <span>
          Lütfen {ids && ids.length > 1 ? "kullanıcıların" : "kullanıcının"} sisteme giriş yapabileceği IP listesini virgülle ayırarak veya alt alta giriniz:
        </span>
        <div className="mt-8">
          <IPListEditForm
            IPList={IPList}
            btnRef={btnRef}
            saveIPList={saveIPList}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={saveIPListClick}
        >
          Kaydet
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={closeIPListEdit}
        >
          Vazgeç
        </button>
      </Modal.Footer>
    </Modal>
  );
}